var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M14.164 17.708H5.831c-3.042 0-4.792-1.75-4.792-4.791V7.083c0-3.041 1.75-4.791 4.792-4.791h8.333c3.042 0 4.792 1.75 4.792 4.791v5.834c0 3.041-1.75 4.791-4.792 4.791M5.831 3.542c-2.384 0-3.542 1.158-3.542 3.541v5.834c0 2.383 1.158 3.541 3.542 3.541h8.333c2.383 0 3.542-1.158 3.542-3.541V7.083c0-2.383-1.159-3.541-3.542-3.541z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M9.997 10.725c-.7 0-1.408-.217-1.95-.658L5.439 7.983a.623.623 0 0 1 .775-.975l2.608 2.084c.633.508 1.708.508 2.342 0l2.608-2.084a.615.615 0 0 1 .875.1.615.615 0 0 1-.1.875l-2.608 2.084c-.534.441-1.242.658-1.942.658"
  })));
};
export default SvgSms;